import { SVGAttributes } from 'react';
import styled from 'styled-components';
import { EXPANDER_RADIUS } from './consts';
import { dispatchAction } from '@ardoq/rxbeach';
import { relationshipDiagramToggleCollapseGroup } from 'tabview/relationshipDiagrams/actions';
import { ViewIds } from '@ardoq/api-types';
import { GroupExpanderVisual } from '@ardoq/graph';

const ExpanderCircleGroup = styled.g`
  cursor: pointer;
`;

type GroupExpanderProperties = {
  groupId: string;
  collapsed: boolean;
  boundsSize: number;
  viewId: ViewIds;
  viewInstanceId: string;
};
const GroupExpander = ({
  groupId,
  collapsed,
  boundsSize,
  viewId,
  viewInstanceId,
  ...rest
}: GroupExpanderProperties & SVGAttributes<SVGGElement>) => {
  const center = boundsSize / 2;

  return (
    <ExpanderCircleGroup
      onClick={() =>
        dispatchAction(
          relationshipDiagramToggleCollapseGroup({ viewId, groupId }),
          viewInstanceId
        )
      }
      {...rest}
    >
      <GroupExpanderVisual
        collapsed={collapsed}
        cx={center}
        cy={center}
        radius={EXPANDER_RADIUS}
      />
    </ExpanderCircleGroup>
  );
};
export { GroupExpander };
